import {Component, Input, OnInit} from '@angular/core';
import {SideMenuSvgSpriteComponent} from './side-menu-svg-sprite.component';
import {ActivatedRoute, RouterLink, RouterLinkActive} from '@angular/router';
import {TenantService} from '../../services/tenant.service';
import {AppState} from '../../store';
import {isAnyAdmin, isLoggedIn, selectTenantInfo} from '../../store/selectors';
import {map} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import {WebsiteBrand} from '../../models/website-brand.model';
import {NgClass, NgFor, NgIf, NgStyle} from '@angular/common';
import {CommunityRoom} from '../../models/community/community-room.model';
import {ManageRoomService} from '../services/manage-room.service';
import {combineLatest} from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  standalone: true,
  imports: [SideMenuSvgSpriteComponent, RouterLinkActive, NgStyle, NgClass,
    RouterLink, NgFor, NgIf, TranslateModule]
})
export class SideMenuComponent implements OnInit {


  brand: WebsiteBrand

  lightPrimaryColor: string;
  rooms: CommunityRoom[] = []

  //mobile menu
  isAdminMobile = false;

  isAdmin: boolean = false;

  isLoggedIn: boolean = false;

  @Input()
  totalRooms: number = 0;

  constructor(
    private tenant: TenantService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private roomsService: ManageRoomService) {
  }

  ngOnInit() {

    this.roomsService.rooms$.subscribe((rooms: CommunityRoom[])=> {
      this.rooms = rooms.filter(room => room.enabled);
    });

    combineLatest([
      this.store.pipe(select(selectTenantInfo)),
      this.store.pipe(select(isLoggedIn)),
      this.store.pipe(select(isAnyAdmin))
      ])
      .subscribe(([tenant, isLoggedIn, isAdmin]) => {
        this.brand = tenant?.brandTheme;
        this.lightPrimaryColor = this.brand?.primaryColor + '15';
        this.isLoggedIn = isLoggedIn;
        this.isAdmin = isAdmin;
      });
  }

  toggleCommunityMobileMenu(event: Event) {
    event.preventDefault();
    this.isAdminMobile = !this.isAdminMobile;
  }

}
